import Container from "react-bootstrap/Container";
import { Card, Form, Row, Col, Table } from "react-bootstrap";
import logo from "../images/logo.webp";
import DateRangeComp from "./DateRangeComp";
import Button from "react-bootstrap/Button";
import React,{useEffect,useState} from "react";
import { Scrollbars } from "react-custom-scrollbars";
import Slider from "react-slick";
import LeadsByMonthGraph from "../Grpahs/LeadsByMonthGraph";
import ContentLoader, { Facebook } from 'react-content-loader'
import ProgressBar from "@ramonak/react-progress-bar";
import  '../CSS/styles.scss'
import TableScrollbar from 'react-table-scrollbar';

// db imports
// import db from "../database/db.json";
// import db1 from "../database/db1.json";
// import YearToDateVisualGraph from "../Grpahs/YearToDateVisualGraph";
import ApplicationDetails2Db from '../database/ApplicationDetails2Db.json'
import Header from "./Header";





const ApplicationsDetails2 = () => {

  const [ttl, setttl]=useState(0);
  const [perTa, setPerTa]=useState(0);
  const [tUniqueA, setTUniqueA]=useState(0);
  const [perTUniqueA, setPerTUniqueA]=useState(0);
  const [applicPerStu, setApplicPerStu]= useState(0);
 


  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1
  };

  useEffect(()=>{
    userAdd();
    userPerAdd();
    totalUniqueAppli();
    perTotalUniqueAppli();
    totalUniqueAppli();
    appliPerStudent();
  },[])
  



  function userAdd(){
    const rec = ApplicationDetails2Db
    var sum=0;
      for(var i=0; i<rec.length; i++){
        sum += parseInt(rec[i].tA)
      }
      setttl(sum)
    }

    function userPerAdd(){
      const rec = ApplicationDetails2Db
      var sum=0;
        for(var i=0; i<rec.length; i++){
          sum += parseInt(rec[i].perTA)
        }
        setPerTa(sum)
      }

      function totalUniqueAppli(){
        const rec = ApplicationDetails2Db
        var sum=0;
          for(var i=0; i<rec.length; i++){
            sum += parseInt(rec[i].tUniqueA)
          }
          setTUniqueA(sum)
        }

        function perTotalUniqueAppli(){
          const rec = ApplicationDetails2Db
          var sum=0;
            for(var i=0; i<rec.length; i++){
              sum += parseInt(rec[i].perTUniqueA)
            }
            setPerTUniqueA(sum)
          }

          function appliPerStudent(){
            const rec = ApplicationDetails2Db
            var sum=0;
              for(var i=0; i<rec.length; i++){
                sum += parseInt(rec[i].appliPerStu)
              }
              setApplicPerStu(sum)
            }

  



      

  return (
    <React.Fragment>
    <Header/>
      <Container fluid style={{height:'80%'}}>
        <Row>
          <Col>
            <Container fluid>
              <Row>
                <Col xs={6} style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={logo}
                    className="d-inline-block align-top"
                    alt="logo"
                  />
                  <h2 style={{ fontSize: "40px" }}>
                    <strong>&nbsp; Applications Details</strong>
                  </h2>
                </Col>
                
                <Col
                  xs={3}
                  
                  
                >
                  <Card
                    className="text-center"
                    style={{
                      position:'initial',
                      
                      boxShadow: "2px 2px 8px ",
                      marginTop:'3px'
                  
                    }}
                  >
                    <Card.Header
                      style={{ backgroundColor: "black", color: "white",padding:'0px'}}
                    >
                      Total Unique Applications
                    </Card.Header>
                    <Card.Body
                      style={{ padding: "0px", textAlign: "center"}}
                    >
                      <h1>903</h1>
                    </Card.Body>
                  </Card>
                  </Col>
                  
                  <Col xs={3}>
                  <Card
                    className="text-center"
                    style={{
                      position:'initial',
                      
                      boxShadow: "2px 2px 8px ",
                      marginTop:'3px',
                    }}
                  >
                    <Card.Header
                      style={{ color: "white", backgroundColor: "black",padding:'0px'}}
                    >
                            Total Applications
                    </Card.Header>
                    <Card.Body style={{ padding: "0px" }}>
                      
                            <h1>2617</h1>




                    </Card.Body>
                    </Card>
                  </Col>
                
              </Row>
            </Container>
          </Col>
        </Row>
        <Row>
          <Col>
            <hr
              style={{
                height: "4px",
                borderWidth: "0",
                color: "black",
                backgroundColor: "black",
                marginTop: "7px",
                marginBottom: "5px",
                position:'initial',
              }}
            ></hr>
          </Col>
        </Row>
        <Row>
          <Col xs={2}>
            <Card style={{ boxShadow: "2px 2px 8px " }}>
              <Card.Header style={{ color: "white", backgroundColor: "black",padding:'0px'}}>
                Select User
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>All</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={2}>
            <Card style={{ boxShadow: "2px 2px 8px ",position:'initial' }}>
              <Card.Header style={{ color: "white", backgroundColor: "black",padding:'0px'}}>
                Select Branch
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>All</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={2}>
            <Card
              style={{
                boxShadow: "2px 2px 8px ",
                paddingTop: "0px",
                paddingBottom: "8px",
                position:'initial',
              }}
            >
              <Card.Header style={{ color: "white", backgroundColor: "black",padding:'0px' }}>
                Select Destination
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>All</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
         
          <Col xs={2}>
              
          <Card
          style={{
            boxShadow: "2px 2px 8px ",
            paddingTop: "0px",
            paddingBottom: "8px",
            position:'initial',
          }}
        >
          <Card.Header style={{ color: "white", backgroundColor: "black" ,padding:'0px'}}>
            Select Month
          </Card.Header>
          <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
            <Form.Select
              aria-label="Default select example"
              style={{ border: "none" }}
            >
              <option>All</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </Form.Select>
          </Card.Body>
        </Card>
          
          </Col>
          <Col xs={2}>

          <Card
          style={{
            boxShadow: "2px 2px 8px ",
            paddingTop: "0px",
            paddingBottom: "10px",
            height: "70px"
            
            
          }}
        >
          <Card.Header style={{ color: "white", backgroundColor: "black", padding:'0px' }}>
            Date Range
          </Card.Header>
          <Card.Body style={{ padding: "5px"}}>
            <DateRangeComp />
          </Card.Body>
        </Card>
              
          
          
          </Col>
          <Col xs={2}>
          <Card style={{ boxShadow: "2px 2px 8px " ,position:'initial'}}>
            <Card.Header style={{ color: "white", backgroundColor: "black", padding:'0px'}}>
              Select Lead Stage
            </Card.Header>
            <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
              
              <Slider {...settings} className='slider' >
                  <div >
                    <Button variant="secondary" style={{padding:'5px'}} >2017</Button>
                  </div>
                  <div>
                    <Button variant="secondary" style={{padding:'5px'}}>2018</Button>
                  </div>
                  <div>
                    <Button variant="secondary" style={{padding:'5px'}}>2019</Button>
                  </div>
                  <div>
                    <Button variant="secondary" style={{padding:'5px'}}>2020</Button>
                  </div>
                  <div>
                    <Button variant="secondary" style={{padding:'5px'}}>2021</Button>
                  </div>
                  <div>
                    <Button variant="secondary" style={{padding:'5px'}}>2022</Button>
                  </div>
                  
                    
                  
                </Slider>
              
            </Card.Body>
          </Card>
        </Col>
        </Row>
        <Row style={{paddingTop:'5px'}} >
          <Col xs={4}>

          <Card style={{height:'180px', boxShadow: "2px 2px 8px ",position:'initial'}}>
        
          <Card.Title style={{ textAlign:'center',textDecoration:'underline 1.5px',marginBottom:'0px',backgroundColor:'black',color:'white'}}>Top 5 Universities with Highest Number of Applicationd</Card.Title>
          <Card.Body className="intrest" style={{padding:'5px'}}>
          
          <Scrollbars style={{ height: "100%", width: "100%"}}>
              <div style={{ paddingRight: "15px"}}>
          <Card style={{position:'initial'}}>
          <Card.Body style={{padding:'1px 10px',position:'initial'}}>
          <Card.Subtitle>Australia</Card.Subtitle>
          <Card.Subtitle>6456</Card.Subtitle>
          <Card.Text >Lead</Card.Text>
          </Card.Body>
          </Card>
          <Card style={{position:'initial'}}>
          <Card.Body style={{padding:'1px 10px'}}>
          <Card.Subtitle>Australia</Card.Subtitle>
          <Card.Subtitle>6456</Card.Subtitle>
          <Card.Text>Lead</Card.Text>
          </Card.Body>
          </Card>
          <Card>
          <Card.Body style={{padding:'1px 10px'}}>
          <Card.Subtitle>Australia</Card.Subtitle>
          <Card.Subtitle>6456</Card.Subtitle>
          <Card.Text>Lead</Card.Text>
          </Card.Body>
          </Card>
          <Card>
          <Card.Body style={{padding:'1px 10px'}}>
          <Card.Subtitle>Australia</Card.Subtitle>
          <Card.Subtitle>6456</Card.Subtitle>
          <Card.Text>Lead</Card.Text>
          </Card.Body>
          </Card>
          <Card>
          <Card.Body style={{padding:'1px 10px'}}>
          <Card.Subtitle>Australia</Card.Subtitle>
          <Card.Subtitle>6456</Card.Subtitle>
          <Card.Text>Lead</Card.Text>
          </Card.Body>
          </Card>
          </div>
          </Scrollbars>
            
          </Card.Body>

        </Card>
          
          </Col>
          <Col xs={4}>
          
          <Card style={{height:'180px', boxShadow: "2px 2px 8px ",position:'initial'}}>
        
          <Card.Title style={{ textAlign:'center',textDecoration:'underline 1.5px',marginBottom:'0px',backgroundColor:'black',color:'white' }}>5 Universities with Highest Number of Applications withdraw </Card.Title>
          <Card.Body className="intrest" style={{padding:'5px'}}>
          
          <Scrollbars style={{ height: "100%", width: "100%" }}>
              <div style={{ paddingRight: "15px" }}>
          <Card>
          <Card.Body style={{padding:'1px 10px'}}>
          <Card.Subtitle>Australia</Card.Subtitle>
          <Card.Subtitle>6456</Card.Subtitle>
          <Card.Text >Lead</Card.Text>
          </Card.Body>
          </Card>
          <Card>
          <Card.Body style={{padding:'1px 10px'}}>
          <Card.Subtitle>Australia</Card.Subtitle>
          <Card.Subtitle>6456</Card.Subtitle>
          <Card.Text>Lead</Card.Text>
          </Card.Body>
          </Card>
          <Card>
          <Card.Body style={{padding:'1px 10px'}}>
          <Card.Subtitle>Australia</Card.Subtitle>
          <Card.Subtitle>6456</Card.Subtitle>
          <Card.Text>Lead</Card.Text>
          </Card.Body>
          </Card>
          <Card>
          <Card.Body style={{padding:'1px 10px'}}>
          <Card.Subtitle>Australia</Card.Subtitle>
          <Card.Subtitle>6456</Card.Subtitle>
          <Card.Text>Lead</Card.Text>
          </Card.Body>
          </Card>
          <Card>
          <Card.Body style={{padding:'1px 10px'}}>
          <Card.Subtitle>Australia</Card.Subtitle>
          <Card.Subtitle>6456</Card.Subtitle>
          <Card.Text>Lead</Card.Text>
          </Card.Body>
          </Card>
          </div>
          </Scrollbars>
            
          </Card.Body>

        </Card>

          </Col>
          <Col xs={4}>
          
          <Card style={{height:'180px', boxShadow: "2px 2px 8px ",position:'initial'}}>
        
          <Card.Title style={{ textAlign:'center',textDecoration:'underline 1.5px',marginBottom:'0px',backgroundColor:'black',color:'white' }}>5 Universities with Highest Number of Applications Rejected</Card.Title>
          <Card.Body className="intrest" style={{padding:'5px'}}>
          
          <Scrollbars style={{ height: "100%", width: "100%" }}>
              <div style={{ paddingRight: "15px" }}>
          <Card>
          <Card.Body style={{padding:'1px 10px'}}>
          <Card.Subtitle>Australia</Card.Subtitle>
          <Card.Subtitle>6456</Card.Subtitle>
          <Card.Text >Lead</Card.Text>
          </Card.Body>
          </Card>
          <Card>
          <Card.Body style={{padding:'1px 10px'}}>
          <Card.Subtitle>Australia</Card.Subtitle>
          <Card.Subtitle>6456</Card.Subtitle>
          <Card.Text>Lead</Card.Text>
          </Card.Body>
          </Card>
          <Card>
          <Card.Body style={{padding:'1px 10px'}}>
          <Card.Subtitle>Australia</Card.Subtitle>
          <Card.Subtitle>6456</Card.Subtitle>
          <Card.Text>Lead</Card.Text>
          </Card.Body>
          </Card>
          <Card>
          <Card.Body style={{padding:'1px 10px'}}>
          <Card.Subtitle>Australia</Card.Subtitle>
          <Card.Subtitle>6456</Card.Subtitle>
          <Card.Text>Lead</Card.Text>
          </Card.Body>
          </Card>
          <Card>
          <Card.Body style={{padding:'1px 10px'}}>
          <Card.Subtitle>Australia</Card.Subtitle>
          <Card.Subtitle>6456</Card.Subtitle>
          <Card.Text>Lead</Card.Text>
          </Card.Body>
          </Card>
          </div>
          </Scrollbars>
            
          </Card.Body>

        </Card>
          
          </Col>
        </Row>
        <Row style={{marginTop:'5px'}}>
          <Col>  
          <Card style={{boxShadow: "2px 2px 8px ",height:'290px',position:'initial',}}>
          
          
          <Card.Body style={{padding:'5px'}}>
          <div style={{height: "30vh"}}>
          <TableScrollbar rows={9.2}>
          
          
          <Table responsive="sm">
          
          <thead className="tableHeader">
            <tr>
            <th>
            Destination
            </th>
            <th>Total Applications</th>
            <th>% of Total Application</th>
            <th>Total Unique Applications</th>
            <th>% of Total Unique Application</th>
            <th>Application per Student</th>
            
            </tr>
          </thead>
         
          
          <tbody >
          
          
         
          
          {
          ApplicationDetails2Db.map((user=>(
            
             

 
               <tr>

              <td>{user.desti}</td>
              <td >
              
              <ProgressBar 
              completed={user.tA}
              customLabel={user.tA}
              labelClassName="label"
              maxCompleted={1600}
              bgColor='#168cf9'
             
              
              
               />
              
              
              
              </td>
              
              <td className="percentae" >{user.perTA}%</td>
              <td className="percentge">
              
              <ProgressBar 
              completed={user.tUniqueA}
              customLabel={user.tUniqueA}
              labelClassName="label"
              maxCompleted={400}
              bgColor='#ff6666'
              baseBgColor='none'
             
              
              
               />
              
              </td>
              <td className="percenage">{user.perTUniqueA}%</td>
              <td className="percetage">
              
              <ProgressBar 
              completed={user.appliPerStu}
              customLabel={user.appliPerStu}
              
              maxCompleted={5}
              // bgColor='#eb8a5f'
              backgroundColor= '["red", "blue", "green", "blue", "red", "blue"]'
              baseBgColor='none'
              className="wrapper"
              barContainerClassName="container"
              completedClassName="barCompleted"
              labelClassName="label"
              

               />
              </td> 
               </tr>


              
             )))

             
           }
           
           
          
          <tr style={{position:'sticky',boxShadow: "1px -4px 18px 0px orangered", backgroundColor:'#5560ee', color:'white'}}>
          <td><strong>Total:</strong></td>
          <td><strong>{ttl}</strong>
          </td>
          <td><strong>{perTa}</strong></td>
          <td><strong>{tUniqueA}</strong></td>
          <td><strong>{perTUniqueA}</strong></td>
          <td><strong>{parseFloat(applicPerStu).toFixed(2)}</strong></td>
          </tr>
          
          
           
           
           

           
           
           
           
           
          
          
          </tbody>
          
          
          
          
          
          
          
          </Table>
          </TableScrollbar>
          
          
           </div>
           
           

        


          
          


          </Card.Body>
          
          
          </Card>

          
          </Col>
        </Row>
        </Container>
        </React.Fragment>
  )
}
  export default ApplicationsDetails2;